export enum WMS_COMMANDS {
  GET_FIREBASE_TOKEN = 'getFcmToken',
  LOG = 'log',
  LOADING = 'loading',
  SET_LANGUAGE = 'setLanguage',
  PLAY_SOUND = 'playSound',
  DOWNLOAD_FILE = 'downloadFile',
  COPY_TO_CLIPBOARD = 'copyToClipboard',
  LOGOUT = 8,
  SET_SETTINGS = 9,
  APP_STATE_CHANGE = 'APP_STATE_CHANGE',
}
// export enum WMS_COMMANDS {
//     GET_FIREBASE_TOKEN = 'getFcmToken'
// }

export type TWMS_COMMAND = keyof typeof WMS_COMMANDS;
